import type { RouteRecordRaw } from "vue-router";

export const FlowEditorRoutes: RouteRecordRaw[] = [
  {
    path: "flow-editor/:id",
    name: "flowEditor",
    component: () => import("@/domain/Flows/FlowEditor/presentation/pages/FlowEditorPage.vue"),
    meta: { requiresAuth: true, permissions: "flows.read" },
  },
];
